<template>
  <div>
    <v-toolbar color="grey lighten-3" light>
      <v-toolbar-title>Info</v-toolbar-title>
    </v-toolbar>

    <v-card-text style="color:grey">{{explanation}}</v-card-text>
    <v-list two-line subheader>
      <div v-for="item in infos" :key="item.title">
        <v-subheader v-if="item.type==='subheader'" inset>{{item.text}}</v-subheader>
        <v-list-tile v-else avatar>
          <v-list-tile-avatar>
            <v-icon :color="item.color" :class="[item.iconClass]">{{ item.icon }}</v-icon>
          </v-list-tile-avatar>

          <v-list-tile-content>
            <v-list-tile-title v-if="item.title">{{ item.title }}</v-list-tile-title>
            <v-list-tile-sub-title v-if="item.subtitle">{{ item.subtitle }}</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <!-- <v-list-tile-action>
                    <v-btn icon ripple>
                      <v-icon color="grey lighten-1">info</v-icon>
                    </v-btn>
        </v-list-tile-action>-->
      </div>
    </v-list>
  </div>
</template>

<script>
export default {
  props: ["infos", "explanation"]
};
</script>

<style>
</style>
